module.exports = __webpack_public_path__ + "img/hq.ffdb5214.png";